module.exports = __webpack_public_path__ + "img/iconeConfiguracoes.7b9c9647.png";